import { addCartItem } from "../../../../services/cartShoppingService";
import { ProductType } from "../../../../store/slice/productsSlice";
import { AppDispatch } from "../../../../store/store";
import { getPrice } from "../../../../utils/getPrice";
import "./ProductItem.scss";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const ProductItem = (props: ProductType) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const addProductToCart = () => {
    props.Code &&
      dispatch(
        addCartItem({
          productCode: props.Code,
          quantity: 1,
        })
      );
  };

  return (
    <div className="product-item">
      <div
        onClick={() =>
          navigate(
            `/category-product/${props.Category?.code}/${props.SubCategory?.code}/${props.Code}`
          )
        }
      >
        <div>
          <img src={props.ImageUrl} alt={props.Designation} />
        </div>
      </div>
      <div className="product-desc">
        <div id="name" title={props.Designation}>
          {`${props.Designation?.slice(0, 40)}${
            props.Designation && props.Designation?.length > 40 ? "..." : ""
          }
        `}
        </div>
        <div>
          <div id="ref">Réf: {props.Reference}</div>
          <div className="product-footer">
            <div>
              {/* {props.oldPrice && <p id="old-price">{props.oldPrice}</p>} */}
              <p id="price">
                {getPrice(props.PrixHT, props.TVATaux)
                  .toString()
                  .replace(".", ",")}
                € HT
              </p>
            </div>
            <button
              onClick={addProductToCart}
              // className={
              //   props?.StockQuantity && props.StockQuantity > 0 ? "" : "out"
              // }
            >
              Ajouter au panier
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
